import { ApplicationRoutes } from './../../@core/routes/application-routes.const';
import { Injectable } from '@angular/core';
import { ApiClientService } from 'src/app/@core/services/api-client.service';

@Injectable({
  providedIn: 'root'
})
export class PlatformFaqService {

constructor(private apiClient: ApiClientService) { }
  getAllPlatformFaq()
  {
    return this.apiClient.get(`${ApplicationRoutes.PlatformFaq.AllQuestions}`)
  }

  getAllPlatformFaqsbyLanguageId(languageId: number)
  {
    return this.apiClient.get(`${ApplicationRoutes.PlatformFaq.ListByLanguage(languageId)}`)
  }
}
